// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { createAsyncAction } from 'typesafe-actions';
import { ILTCourse } from '../../../types/Model';

export interface IltCourseRequestPayload {
  id: number;
  preventLoading?: boolean;
}
export interface IltCourseSuccessPayload {
  iltCourseData: ILTCourse;
}

export interface IltCourseFailPayload {
  error: Error;
}

const getIltCourseDataActions = createAsyncAction(
  'elearning/GET_ILT_COURSE_DATA',
  'elearning/GET_ILT_COURSE_DATA_SUCCESS',
  'elearning/GET_ILT_COURSE_DATA_FAIL'
)<
  IltCourseRequestPayload,
  IltCourseSuccessPayload,
  IltCourseFailPayload
>();

export { getIltCourseDataActions as default }
